module.exports = __webpack_public_path__ + "media/images/index/feature/top-poj-9ffa238de13039fc4806d5bfbaca4975.png";